import { Space } from '../mainApi';
import { IUser } from '../interfaces/IUser';

export const isActiveOwnedSpace = (space: Space) =>
  space.archived !== true && space.isOwner !== false;

export const hasReachedActiveOwnedSpaceLimit = (user: IUser | null | undefined, spaces: Space[]) =>
  Boolean(
    user &&
      (user.accountLevel ?? 0) <= 0 &&
      spaces.filter(isActiveOwnedSpace).length >= 3
  );
